export function renderCobrandBanner () {
  const cobrandBanner =
    document.getElementsByClassName('cobrand-banner')[0]
  if (cobrandBanner) { cobrandBanner.removeAttribute('style') }
}
